import { authUserData } from ".";
import {
  PushNotificationService as GeneratedPushNotificationService,
  type SendAnnouncementRequest,
  callApi,
  configureApiClient,
} from "../api/client";

export type AnnouncementType = 0 | 1;

export type AnnouncementPayload = {
  announcementType: AnnouncementType;
  title: string;
  message: string;
  teamCode?: string | null;
};

export type AnnouncementResponse = {
  success: boolean;
  message: string;
  sentCount?: number;
  announcementType?: AnnouncementType;
};

const configurePushNotificationApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

type ApiClientError = Error & { body?: unknown };

export const sendAnnouncement = async (payload: AnnouncementPayload): Promise<AnnouncementResponse | null> => {
  try {
    configurePushNotificationApiClient();
    const request: SendAnnouncementRequest = {
      announcementType: payload.announcementType,
      title: payload.title,
      message: payload.message,
      teamCode: payload.teamCode,
    };
    const data = await callApi(
      () => GeneratedPushNotificationService.postApiPushNotificationSendAnnouncement(request),
      "公告發送失敗，請稍後再試。"
    );
    return data as AnnouncementResponse;
  } catch (error) {
    const apiError = error as ApiClientError;
    const body = apiError?.body as { message?: string } | string | undefined;
    if (body) {
      return {
        success: false,
        message:
          (typeof body === "string" ? body : body.message) ||
          "公告發送失敗，請稍後再試。",
      };
    }
    return {
      success: false,
      message: "公告發送失敗，請稍後再試。"
    };
  }
};
